import { AlarmePage } from './Alarme'
import { EinstellungenPage } from './Einstellungen'
import { UebersichtPage } from './Uebersicht'
import { GeraetePage } from './Geraete'
import { StandortePage } from './Standorte'
import { FernzugriffPage } from './Fernzugriff'
import { ConfigsPage } from './Configs'
import { PortFinderPage } from './PortFinder'
import { TopologiePage } from './Topologie'
import { SyslogPage } from './Syslog'
import { BerichtePage } from './Berichte'
import { DienstePage } from './Dienste'

interface ScopeProps {
  customerSlug: string | null
}

export const PAGE_COMPONENTS: Record<string, (props: ScopeProps) => JSX.Element> = {
  '': UebersichtPage,
  alarme: AlarmePage,
  geraete: GeraetePage,
  standorte: StandortePage,
  fernzugriff: FernzugriffPage,
  configs: ConfigsPage,
  portfinder: PortFinderPage,
  topologie: TopologiePage,
  dienste: DienstePage,
  syslog: SyslogPage,
  berichte: BerichtePage,
  einstellungen: () => <EinstellungenPage />,
}
